<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.pi_inoutno}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="pi_vendname">
            <label class="weui-form-preview__label">{{customLabel.pi_vendname || "供应商名称"}}</label>
            <em class="weui-form-preview__value">{{form.main.pi_vendname}}</em>
          </div>
          <div class="weui-form-preview__item" slot="pi_date">
            <label class="weui-form-preview__label">{{customLabel.pi_date || "领料日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.pi_date}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" slot="pi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" slot="pi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" slot="pi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" slot="pi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" slot="pi_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.pd_pdno}}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="pd_ordercode">
            <label class="weui-form-preview__label">{{customLabel.pd_ordercode || "外协单"}}</label>
            <span class="weui-form-preview__value">{{item.pd_ordercode}} 序号 {{item.pd_orderdetno}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品"}}</label>
            <span
              class="weui-form-preview__value"
            >{{item.pd_prodcode}} {{item.productDTO.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_brand" slot="pr_brand">
            <label class="weui-form-preview__label">{{customLabel.pr_brand || "品牌"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_whname">
            <label class="weui-form-preview__label">{{customLabel.pd_whname || "仓库"}}</label>
            <span class="weui-form-preview__value">{{item.pd_whname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_outqty">
            <label class="weui-form-preview__label">{{customLabel.pd_outqty || "领料数量"}}</label>
            <span class="weui-form-preview__value">
              <span>{{numberFormat(item.pd_outqty,'#,##0.#')}}</span>
              &nbsp;{{item.productDTO.pr_unit}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="qty" v-if="item.qty">
            <label class="weui-form-preview__label">{{
              customLabel.qty || "辅助数量"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ item.qty }} {{ item.productDTO.pr_unit_extra }}</span
            >
          </div>
          <div class="weui-form-preview__item" slot="pd_actoutqty">
            <label class="weui-form-preview__label">{{customLabel.pd_actoutqty || "实发数量"}}</label>
            <span class="weui-form-preview__value">
              <span>{{numberFormat(item.pd_actoutqty,'#,##0.#')}}</span>
              &nbsp;{{item.productDTO.pr_unit}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="pd_price">
            <label class="weui-form-preview__label">{{customLabel.pd_price || "成本单价(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.pd_price,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_total">
            <label class="weui-form-preview__label">{{customLabel.pd_total || "金额(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.pd_total,'#,##0.00')}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pd_text1 || '自定义字段1'"
          v-model="item.pd_text1" slot="pd_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text2 || '自定义字段2'"
          v-model="item.pd_text2" slot="pd_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text3 || '自定义字段3'"
          v-model="item.pd_text3" slot="pd_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text4 || '自定义字段4'"
          v-model="item.pd_text4" slot="pd_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pd_text5 || '自定义字段5'"
          v-model="item.pd_text5" slot="pd_text5" hidden="true" />
           </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">金额合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{form.main.pi_costtotal}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/make/prodinout",
      caller:'OsMakePick',
      xtype:'osmake-osmakepick-formpanel'
    };
  }
};
</script>